import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClindamycinGlyph from './svgs/ClindamycinGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clindamycinGlyph = (props => useIcon(SvgClindamycinGlyph, null, props));

export { clindamycinGlyph as default };
